import { getChainConnection } from './getChainConnection';

export const checkObsession = (positionFrom, allPositions, positionTo) => {
    const guids = [positionTo, ...getChainConnection(positionTo, allPositions)].map(
        (position) => position.guid
    );
    return guids.includes(positionFrom.guid);
};
